import type {
  LC_EmployeeDocumentItemOut,
  LC_DocumentTypeItem,
  LC_CompanyFolderItem,
  EmployeeDocument,
  DocumentType,
  CompanyFolder,
} from '../types/employeeDocument.types';
import { formatToDdMmYyyy } from '@/utils';


export function mapEmployeeDocumentItem(item: LC_EmployeeDocumentItemOut): EmployeeDocument {
  return {
    id: item.id,
    folderId: item.folderId,
    folderName: item.folderName ?? '',
    documentName: item.documentName ?? '',
    documentType: item.documentType ?? '',
    createdAt: item.createdAt ? formatToDdMmYyyy(new Date(item.createdAt)) : '',
    storageFileId: item.storageFileId,
  };
}

export function mapDocumentTypeItem(item: LC_DocumentTypeItem): DocumentType {
  return {
    id: item.id,
    name: item.name ?? '',
  };
}

export function mapCompanyFolderItem(item: LC_CompanyFolderItem): CompanyFolder {
  return {
    id: item.folderId,
    name: item.folderName ?? '',
  };
}
